export enum UserRoles {
    ALL = "All",
    USER = "User",
    ADMIN = "Admin",
    CCA = "Call Center Associates",
    MA = "Marketing Associates",
}
